import { useContext } from 'react';
import { UserConfigContext } from './userConfigContext';

export function useUserConfig() {
  const context = useContext(UserConfigContext);

  if (context === null) {
    throw new Error('useUserConfig must be used within UserConfigProvider');
  }

  return context;
}
